import { render, staticRenderFns } from "./postBluesky.vue?vue&type=template&id=3cff13ee"
import script from "./postBluesky.vue?vue&type=script&lang=js"
export * from "./postBluesky.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cff13ee')) {
      api.createRecord('3cff13ee', component.options)
    } else {
      api.reload('3cff13ee', component.options)
    }
    module.hot.accept("./postBluesky.vue?vue&type=template&id=3cff13ee", function () {
      api.rerender('3cff13ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/renderPost/postBluesky.vue"
export default component.exports